export async function fetchStoreLastOrderId(orderId: string) {
  window.localStorage.setItem('lastOrderId', orderId)
  return orderId
}
